<script setup>

const props = defineProps({
  type: {
    type: String,
    default: 'info',
    validator: value => ['info', 'warning', 'error', 'success'].includes(value)
  },
  title: {
    type: String,
    default: ''
  },
  dismissible: {
    type: Boolean,
    default: false
  },
  text: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:text'])

const isOpen = computed(() => Boolean(props.text))
const close = () => emit('update:text', null)
</script>

<template>
  <VAlert
    border="top"
    variant="tonal"
    border-color
    prominent
    density="compact"
    tile
    class="max-page-alert mb-0"
    :type="type"
    :model-value="isOpen"
    :closable="dismissible"
    @update:model-value="close"
  >
    <template
      v-if="dismissible"
      #close="{ props: closableProps }"
    >
      <VBtn
        size="default"
        variant="text"
        :icon="null"
        color="primary"
        v-bind="closableProps"
      >
        Dismiss
      </VBtn>
    </template>
    <div class="d-flex align-center justify-space-between">
      <span class="text-body-2 text-grey-darken-4">
        <template v-if="title">
          <strong>{{ title }}</strong><br>
        </template>
        {{ text }}
      </span>
      <div v-if="$slots.actions">
        <VDefaultsProvider :defaults="{ VBtn: { variant: 'text', color: 'primary' } }">
          <slot name="actions" />
        </VDefaultsProvider>
      </div>
    </div>
  </VAlert>
</template>

<style lang="scss">
.max-page-alert {
  &.v-alert--prominent {
    grid-template-areas: "prepend content append close";
  }

  .v-alert__close {
    align-self: center;
    margin-inline-start: 0;
  }
}
</style>
